const XCircleSvg = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="x-circle-icon"
  >
    <path
      d="M15 9L9 15M9 9L15 15M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
      stroke="black"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const XCircleBigSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="88" height="88" viewBox="0 0 88 88" fill="none">
    <g>
      <circle cx="45" cy="45" r="37" />
      <path
        d="M55.0002 33L33.0002 55M33.0002 33L55.0002 55M80.6668 44C80.6668 64.2505 64.2506 80.6667 44.0002 80.6667C23.7497 80.6667 7.3335 64.2505 7.3335 44C7.3335 23.7496 23.7497 7.33337 44.0002 7.33337C64.2506 7.33337 80.6668 23.7496 80.6668 44Z"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export default XCircleSvg;
